export const FETCH_VEHICLES_DOCUMENTS_TYPES_DATA = "FETCH_VEHICLES_DOCUMENTS_TYPES_DATA";
export const FETCH_VEHICLES_DOCUMENTS_TYPES_SUCCESS = "FETCH_VEHICLES_DOCUMENTS_TYPES_SUCCESS";
export const FETCH_VEHICLES_DOCUMENTS_TYPES_FAILURE = "FETCH_VEHICLES_DOCUMENTS_TYPES_FAILURE";